export interface ISseEvent
{
	event: string;
	data: string;
}

/**
 * Incremental Server-Sent Events parser. Feed it the text received so far; it returns the complete
 * events and the trailing incomplete block (`rest`) that must be prepended to the next chunk.
 *
 * Events are separated by a blank line, `:`-prefixed lines are comments (keep-alives), `event:` names
 * the event (default `message`) and `data:` lines may repeat and are joined with `\n`.
 */
export function parseSseEvents(buffer: string): { events: ISseEvent[]; rest: string }
{
	const events: ISseEvent[] = [];
	const blocks = buffer.split(/\r?\n\r?\n/);
	// The final block has no terminating blank line yet, so it is incomplete.
	const rest = blocks.pop() ?? '';

	for (const block of blocks)
	{
		let event = 'message';
		const data: string[] = [];
		for (const line of block.split(/\r?\n/))
		{
			if (line.startsWith(':'))
			{
				continue;
			}
			if (line.startsWith('event:'))
			{
				event = line.slice(6).trim();
			}
			else if (line.startsWith('data:'))
			{
				data.push(line.slice(5).trimStart());
			}
		}
		if (data.length > 0)
		{
			events.push({ event, data: data.join('\n') });
		}
	}

	return { events, rest };
}
